export default "/help-portal/faqs-and-inquiries";
